import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./ContactUsReportFraud.css";
import PostCardIcon from "images/contact-us/post.svg";

const ContactUsReportFraud = () => {
    return (
        <WidgetContainer>
            <div className="cu-report-fraud">
                <div className="cu-report-fraud__head">
                    <h1>Report Fraud - Details</h1>
                    <p>
                        Noticing any suspicious activity? Report it to us
                        immediately. Response time: within 24 hours
                    </p>
                </div>
                <div className="cu-report-fraud__content">
                    <div className="cu-report-fraud__content__item">
                        <h2>For Customers</h2>
                        <p>
                            Report fraudulent payments, suspicious communication
                            or any unusual activity on PhonePe.
                        </p>
                        <div className="cu-report-fraud__content__item__cbp">
                            <p>
                                <img
                                    src={PostCardIcon}
                                    width="34"
                                    height="24"
                                    alt="Post Card Icon"
                                />
                            </p>
                            <p>
                                <a
                                    className="purple-text"
                                    href="https://support.phonepe.com/"
                                    target="_top"
                                >
                                    Send a message
                                </a>
                            </p>
                        </div>
                    </div>

                    <div className="cu-report-fraud__content__item">
                        <h2>For Merchants</h2>
                        <p>
                            Found a suspicious activity on your merchant
                            account? Report it to us using this link.
                        </p>
                        <div className="cu-report-fraud__content__item__cbp">
                            <p>
                                <img
                                    src={PostCardIcon}
                                    width="34"
                                    height="24"
                                    alt="Post Card Icon"
                                />
                            </p>
                            <p>
                                <a
                                    className="purple-text"
                                    href="https://support.phonepe.com/"
                                    target="_top"
                                >
                                    Send a message
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default ContactUsReportFraud;
